<script setup lang="ts">
import { PopoverRoot } from 'radix-vue'

defineProps<{
  open?: boolean
  defaultOpen?: boolean
  modal?: boolean
}>()

const emit = defineEmits(['update:open'])
</script>

<template>
  <PopoverRoot v-bind="$props" @update:open="emit('update:open', $event)">
    <slot />
  </PopoverRoot>
</template>
